import { readFileSync } from "node:fs";
import { CONFIG_PATH } from "@/lib/path/config-path-constants";
export function readFileAsObject(): Record<string, unknown> {
  try {
    const parsed: unknown = JSON.parse(readFileSync(CONFIG_PATH, "utf8"));
    // Valid JSON is not necessarily an object: a file holding `null` or a
    // bare string parses fine and then throws on the first property read,
    // taking down every command. Fall back to defaults instead.
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return {};
    }
    return parsed as Record<string, unknown>;
  } catch {
    return {};
  }
}
